
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.446 3.844H1.554c-2.068.03-2.076-3.4 0-3.37h20.892c2.068-.03 2.076 3.4 0 3.37zM1.554 1.44c-.814-.012-.817 1.45 0 1.438h20.892a.6.6 0 00.599-.599c.053-.399-.143-.845-.6-.84H1.556zM22.446 18.317H1.554c-2.068.03-2.076-3.4 0-3.37h20.892c2.068-.03 2.076 3.4 0 3.37zM1.554 15.912c-.814-.011-.817 1.45 0 1.439h20.892a.6.6 0 00.599-.6c.053-.398-.143-.844-.6-.839H1.556z","fill":"#000C1F"}}),_c('path',{attrs:{"d":"M22.016 15.911H1.983a.483.483 0 01-.483-.483V3.36c0-.267.216-.483.483-.483h20.033c.266 0 .483.216.483.483v12.068a.483.483 0 01-.483.483zm-19.55-.966h19.067V3.843H2.466v11.102zM11.998 20.495a.483.483 0 01-.482-.483v-1.974a.483.483 0 01.965 0v1.974a.483.483 0 01-.482.483z","fill":"#000C1F"}}),_c('path',{attrs:{"d":"M12.002 23.528a1.926 1.926 0 01-1.924-1.923c0-1.061.863-1.924 1.924-1.924 1.06 0 1.924.863 1.924 1.924 0 1.06-.863 1.923-1.924 1.923zm0-2.881a.96.96 0 000 1.916.96.96 0 000-1.916zM8.974 7.636h-3.73a.483.483 0 010-.966h3.73a.483.483 0 010 .966zM10.204 9.878h-4.96a.483.483 0 010-.966h4.96a.483.483 0 010 .966zM9.371 12.12H5.245a.483.483 0 010-.966H9.37a.483.483 0 010 .966z","fill":"#000C1F"}})])
          )
        }
      }
    